import { useSortable } from '@dnd-kit/sortable';
import React from 'react';
import { CSS } from '@dnd-kit/utilities';
import ProfileBlock from './ProfileBlock';
import HeadingBlockOfCard from './HeadingBlockOfCard';
import ContactBlock from './ContactBlock';
import ImageBlockOfCard from './ImageBlockOfCard';
import SocialLinkBlock from './SocialLinkBlock';
import LinkBlockOfCard from './LinkBlockOfCard';

const BlockListCard = React.memo(({ blockData, callback, linkId }) => {

    const { attributes, listeners, setNodeRef, transform, transition, } = useSortable({ id: blockData?.order });

    const style = {
        transform: CSS.Translate.toString(transform),
        transition,
    };

    return (
        <div ref={setNodeRef} style={style}>
            <div className='mb-3 bg-white flex gap-3 items-start'>
                {blockData?.blockType == 1 && <ProfileBlock data={blockData} linkId={linkId} callback={() => callback()} dragButton={<button {...attributes} {...listeners}> <img src={process.env.PUBLIC_URL + "/images/grid.svg"} alt="" className='h-6' /> </button>} />}
                {blockData?.blockType == 2 && <HeadingBlockOfCard data={blockData} linkId={linkId} callback={() => callback()} dragButton={<button {...attributes} {...listeners}> <img src={process.env.PUBLIC_URL + "/images/grid.svg"} alt="" className='h-6' /> </button>} />}
                {blockData?.blockType == 3 && <ContactBlock data={blockData} linkId={linkId} callback={() => callback()} dragButton={<button {...attributes} {...listeners}> <img src={process.env.PUBLIC_URL + "/images/grid.svg"} alt="" className='h-6' /> </button>} />}
                {blockData?.blockType == 4 && <ImageBlockOfCard data={blockData} linkId={linkId} callback={() => callback()} dragButton={<button {...attributes} {...listeners}> <img src={process.env.PUBLIC_URL + "/images/grid.svg"} alt="" className='h-6' /> </button>} />}
                {blockData?.blockType == 5 && <SocialLinkBlock data={blockData} linkId={linkId} callback={() => callback()} dragButton={<button {...attributes} {...listeners}> <img src={process.env.PUBLIC_URL + "/images/grid.svg"} alt="" className='h-6' /> </button>} />}
                {blockData?.blockType == 6 && <LinkBlockOfCard data={blockData} linkId={linkId} callback={() => callback()} dragButton={<button {...attributes} {...listeners}> <img src={process.env.PUBLIC_URL + "/images/grid.svg"} alt="" className='h-6' /> </button>} />}
            </div>
        </div>
    )
})

export default BlockListCard